import { NewDiaryInviteScreen } from "@/features/auth/screens/NewDiaryInviteScreen";
import { createFileRoute } from "@tanstack/react-router";

const NewDiaryInvitePage = () => {
    const { organisationName } = Route.useSearch();
    return <NewDiaryInviteScreen organisationName={organisationName} />;
};

export const Route = createFileRoute("/_auth/new-diary-invite")({
    component: NewDiaryInvitePage,
    validateSearch: (search: Record<string, unknown>) => {
        const organisation = search.organisation;
        const nestedName =
            organisation && typeof organisation === "object" && "organisation_name" in organisation
                ? (organisation as { organisation_name?: unknown }).organisation_name
                : undefined;
        const organisationName =
            typeof nestedName === "string"
                ? nestedName
                : typeof search.organisation_name === "string"
                  ? search.organisation_name
                  : undefined;
        return { organisationName };
    },
});
